import NavLink from 'components/NavLink';
import styled from '@emotion/styled';
import type { Theme } from 'styles/themes/default';

const TermsLink = styled(NavLink)(({ theme }: { theme: Theme }) => ({
  color: theme.colors.blueNew['600'],
}));

export default TermsLink;
